const attributeOverflowMixin = {
  data() {
    return {
      expanded: false,
    };
  },
  computed: {
    limitValue() {
      const total = this.items.length;
      return this.expanded ? total : Math.min(total, this.defaultLimit);
    },
    limitedItems() {
      return this.items.slice(0, this.limitValue);
    },
    hasOverflow() {
      return this.items.length > this.defaultLimit;
    },
    isExpanded() {
      return this.expanded && this.items.length > 0;
    },
    overflowCount() {
      return Math.max(this.items.length - this.defaultLimit, 0);
    },
  },
  methods: {
    toggleMoreDetails() {
      this.expanded = !this.expanded;
    },
    itemKey(item) {
      return item.id || `${item.label}-${item.info}`;
    },
  },
};

export default attributeOverflowMixin;
